import BlockIcon from "@mui/icons-material/Block";
import { Box, Typography } from "@mui/material";
import { usePermissions } from "context/PermissionsProvider";
import { Permissions } from "data/permissons";
import useQueryParams from "hooks/useQueryParams";
import { useLocation } from "react-router-dom";

interface Props {
  name: Permissions | Array<string>;
  children: React.ReactNode | null;
  path:string| null;
}

function PathWithPermission({ name, children,path }: Props) {
  let { permissions, role } = usePermissions();
  const location = useLocation();
  const { queryParams } = useQueryParams();

  if (role?.defaultRole) {
    return <>{children}</>;
  }

  if (Array.isArray(name)) {
    let isPermitted = name.some((item) => permissions.includes(item));
    if (!isPermitted && path && path === location.pathname && !queryParams) {
        return <PermissionDenied />;
      }
    return isPermitted ? <>{children}</> : <PermissionDenied />;
    
  }

  if(!queryParams.serviceId){
    if (permissions.includes(name)) {
        return <>{children}</>;
      }
  }else if(queryParams.serviceId){
    if (permissions.includes('services_edit')) {
        return <>{children}</>;
      }
  }
   

  return <PermissionDenied />;
}

const PermissionDenied = () => (
  <Box
    minHeight="80vh"
    display="flex"
    justifyContent="center"
    alignItems="center"
  >
    <Box
      p={2}
      borderRadius={2}
      minWidth={300}
      textAlign="center"
      bgcolor="rgb(253, 237, 237)"
    >
      <BlockIcon
        fontSize="large"
        sx={{
          color: "rgb(95, 33, 32)",
        }}
      />
      <Typography variant="subtitle2" color="rgb(95, 33, 32)">
        Permission Denied
      </Typography>
    </Box>
  </Box>
);

export default PathWithPermission;
